export function isIntegrationReconciliationRequest(config) {
  return Boolean(config && config.integrationReconciliationRequest)
}

export function integrationReconciliationError(body, httpStatus) {
  const businessCode = body && typeof body.code === 'number' ? body.code : null
  const unauthorized = httpStatus === 401 || businessCode === 401
  const forbidden = httpStatus === 403 || businessCode === 403
  // A business 500 can follow committed batches. Never infer total rollback from it.
  const rejected = unauthorized || forbidden || [400, 404, 405].indexOf(httpStatus) !== -1
  const message = unauthorized ? '登录身份已失效，请重新登录。'
    : forbidden ? '没有发布通知维护权限，请联系管理员。'
      : rejected ? '本次操作未被接受，请联系负责人检查操作权限或页面是否可用。'
        : '操作结果暂无法确认，部分处理可能已经完成。请联系负责人核实发布记录和通知发送情况后再操作。'
  // Retain no arbitrary server message, error, response, request body or headers.
  return { kind: rejected ? 'rejected' : 'unknown', message, unauthorized, forbidden,
    httpStatus: typeof httpStatus === 'number' ? httpStatus : null, businessCode }
}



// WEBPACK FOOTER //
// ./src/utils/integrationReconciliationRequest.js